import { useState } from "react";
import GamePage from "./pages/Game";
import IndexPage from "./pages/index";
import "tippy.js/dist/tippy.css";
import categories from "./data/categories";
import ls from "local-storage";

function App() {
  const [terms, setTerms] = useState([]);
  const [timeLimit, setTimeLimit] = useState();
  const [difficulty, setDifficulty] = useState();
  const [category, setCategory] = useState();
  const [inGame, setInGame] = useState(false);
  const [highScore, setHighScore] = useState(
    categories.reduce((obj, item) => {
      //console.log(item);
      return { ...obj, [item.label]: ls.get(item.label) || 0 };
    }, {})
  );

  if (inGame) {
    //console.log("TERMS", terms);
    return (
      <GamePage
        terms={terms}
        timeLimit={timeLimit}
        category={category}
        difficulty={difficulty}
        setInGame={setInGame}
        highScore={highScore}
        setHighScore={setHighScore}
      />
    );
  }

  return (
    <IndexPage
      timeLimit={timeLimit}
      setTimeLimit={setTimeLimit}
      difficulty={difficulty}
      setDifficulty={setDifficulty}
      category={category}
      setCategory={setCategory}
      setInGame={setInGame}
      setTerms={setTerms}
      highScore={highScore}
    />
  );
}

export default App;
